import React, {useContext} from "react"
import {CORE_AMZL, HEADERS} from "../util/Constants";
import PageHeader from "../util/PageHeader";
import AlertView from "../alert/AlertView";
import RoutePickStatus from "../routePickStatus/RoutePickStatus";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AssociateContext} from "../associate/context/AssociateContextProvider";
import AssociateDetailView from "../associate/AssociateDetailView";
import OutboundBanners from "../outboundBanners";
import PickFilterViewV2 from "./PickFilterViewV2";
import PickOverAllStatus from "./PickOverAllStatus";
import PickFilterView from "./PickFilterView";
import PickOverAllStatusV2 from "./PickOverAllStatusV2";
import Column from "@amzn/meridian/column";
import {isAMZLorARv2} from "../util/Util";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import PickFilterViewV2Wrapper from './PickFilterViewV2Wrapper'
import PickFilterViewWrapper from "./PickFilterViewWrapper";
import {PickViewSelectorContext} from "./context/PickViewSelectorContext";
import {PICK_VIEWS} from "./constants/Constants";
import LayoutGridView from "./LayoutGridView";

const PickRouteView = (props) => {
    const {configViewModel} = useContext(CapabilityContext)
    const {associateViewModel} = useContext(AssociateContext)
    const {spacingInset_shorthand2} = useDeviceLayout()
    const {viewState} = useContext(PickViewSelectorContext)
    return (
        <div>
            {associateViewModel.associate.length === 0 ?
                <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
                    <OutboundBanners />
                    <AlertView />

                    {configViewModel.capability === CORE_AMZL ? viewState === PICK_VIEWS.ROUTE_VIEW ?
                        <PageHeader {...HEADERS.PICK} /> : <PageHeader {...HEADERS.PICK_LAYOUT_GRID_VIEW} /> : null}

                    {isAMZLorARv2(configViewModel.capability) ?
                        <PickFilterViewV2Wrapper>
                            <PickFilterViewV2 />
                        </PickFilterViewV2Wrapper>
                        :
                        <PickFilterViewWrapper>
                            <PickFilterView />
                        </PickFilterViewWrapper>
                    }
                    {isAMZLorARv2(configViewModel.capability) ?
                        <PickOverAllStatusV2 />
                        :
                        <PickOverAllStatus />
                    }
                    {viewState === PICK_VIEWS.ROUTE_VIEW ? <RoutePickStatus history={props.history} /> : <LayoutGridView/>}

                </Column> :
                <AssociateDetailView />
            }
        </div >

    )
}

export default PickRouteView


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickRouteView.js